// Centralized Configuration for $NANA Website
// All editable content, links, and token information in one place

export const siteConfig = {
  // Token Information
  token: {
    name: "NANA",
    symbol: "$NANA",
    fullName: "$NANA",
    blockchain: "Supra",
    contractAddress: "0x6253eb8c732079a4eba6fe8a194461b5051d087ad9d35ddf4a8c087e8f7a1d4e::NANA::NANA",
    totalSupply: "1,000,000,000",
    totalSupplyRaw: 1000000000,
  },

  // Brand & Messaging
  brand: {
    tagline: "The most a-peeling coin on $Supra",
    heroTitle: "Welcome to",
    heroSubtitle: "🚀 The most a-peeling coin on $Supra",
    heroDescription: "Peel in, hodl tight, go bananas. $NANA to the moon 🌕",
    footerTagline: "The most a-peeling coin on Supra 🍌",
  },

  // External Links
  links: {
    buyNana: "https://app.dexlyn.com/?outputCurrency=73&inputCurrency=48",
    dexlyn: "https://app.dexlyn.com/?outputCurrency=73&inputCurrency=48",
    starkeyWallet: "https://starkey.app",
    suprascan: "https://supra.com/explorer",
    whitepaperPdf: "#", // Placeholder - will be updated later
    twitter: "https://twitter.com/NANA_Supra",
    telegram: "https://t.me/NANA_Supra",
  },

  // Social Handles
  social: {
    twitter: "@NANA_Supra",
    telegram: "NANA_Supra",
  },

  // Navigation Items
  navigation: [
    { label: "How to Buy", href: "#how-to-buy", id: "how-to-buy" },
    { label: "Tokenomics", href: "#tokenomics", id: "tokenomics" },
    { label: "Roadmap", href: "#roadmap", id: "roadmap" },
    { label: "News", href: "#news", id: "news" },
    { label: "Whitepaper", href: "#whitepaper", id: "whitepaper" },
  ],

  // How to Buy Steps
  howToBuy: [
    {
      step: 1,
      title: "Download Starkey Wallet and Fund with Supra",
      description: "Get the official Starkey Wallet from your app store or download it directly from their website. Then add Supra tokens to your wallet. You can buy Supra from major exchanges and transfer it to your Starkey Wallet.",
      cta: "Download Wallet",
      ctaLink: "https://starkey.app",
      icon: "wallet",
    },
    {
      step: 2,
      title: "Go to Dexlyn or Atmos and Swap for $NANA",
      description: "Visit Dexlyn or Atmos, the premier DEXs on Supra blockchain. Connect your wallet and swap your Supra for $NANA tokens.",
      buttons: [
        {
          label: "Visit Dexlyn",
          link: "https://app.dexlyn.com/?outputCurrency=73&inputCurrency=48",
        },
        {
          label: "Visit Atmos",
          link: "https://app.atmos.ag/en/swap?sellToken=0x1c9e0855980784c81a175c129f60d7ca026a7efad1863a569da8ed39355c4a72&buyToken=0x0000000000000000000000000000000000000000000000000000000000000001%3A%3Asupra_coin%3A%3ASupraCoin",
        },
      ],
      icon: "swap",
    },
  ],

  // Tokenomics Data
  tokenomics: {
    totalSupply: {
      label: "Total Supply",
      value: "1,000,000,000",
      description: "$NANA Tokens",
    },
    allocation: [
      {
        emoji: "🔒",
        category: "Staking rewards",
        amount: "40M",
        percentage: "4%",
      },
      {
        emoji: "🏦",
        category: "NANA Treasury",
        amount: "50M",
        percentage: "5%",
        contractAddress: "0x30e42e138f836f8b956825cfb71bb955ef4753a466ff98b65e3e47b4cfe2137d",
      },
      {
        emoji: "🍌",
        category: "Founder allocation",
        amount: "50M",
        percentage: "5%",
      },
      {
        emoji: "🔥",
        category: "Strategic burn reserve",
        amount: "60M",
        percentage: "6%",
        contractAddress: "0x7fa0286fd0c135d278396debe419d618992fd0611d07a98939c32c2def7d3fff",
      },
      {
        emoji: "💧",
        category: "Liquidity incentives/reserve",
        amount: "100M",
        percentage: "10%",
        links: [
          {
            url: "https://app.atmos.ag/en/earn/pools/0x8e3ff09152a6959ddf07017a781166c52f6ef882a8907034aec15abb51470685",
            label: "$NANA/$SUPRA LP"
          },
          {
            url: "https://app.atmos.ag/en/earn/pools/0xa3be9c2050d7c167c74e96e0a16943f1761c0eca1174df261efb634aa4daee1f",
            label: "$NANA/$iSUPRA LP"
          }
        ]
      },
      {
        emoji: "🪂",
        category: "Airdrops / ecosystem growth / Giveaways & competitions",
        amount: "300M",
        percentage: "30%",
      },
      {
        emoji: "🌎",
        category: "Public/community circulating",
        amount: "400M",
        percentage: "40%",
      },
    ],
  },

  // Roadmap Phases
  roadmap: [
    {
      phase: 1,
      title: "Launch & Community Building",
      status: "completed",
      items: [
        "Token launch",
        "Community building",
        "Listing on Dexlyn",
      ],
    },
    {
      phase: 2,
      title: "Exchange Listings",
      status: "completed",
      items: [
        "NFT Collection Launch",
        "Major DEX listings available in the Supra ecosystem",
        "Staking Rewards",
        "Liquidity Pool Expansion",
        "Trading Volume Growth",
      ],
    },
    {
      phase: 3,
      title: "NFT Bananas",
      status: "active",
      items: [
        "Utility for $NANA holders",
        "Banana Art Collaborations",
        "More Staking Rewards",
        "Big Marketing Campaign",
      ],
    },
    {
      phase: 4,
      title: "Future Expansion",
      status: "upcoming",
      items: [
        "Under Construction",
        "Exciting new features coming soon...",
        "Stay tuned for updates!",
      ],
    },
  ],

  // Whitepaper Sections
  whitepaper: {
    abstract: "$NANA is a community-driven memecoin built entirely on the Supra ecosystem.",
    sections: [
      {
        id: "vision",
        title: "Vision & Mission",
        icon: "target",
        content: "Building a fun, community-powered memecoin on Supra blockchain.",
      },
      {
        id: "liquidity",
        title: "Liquidity Strategy",
        icon: "droplets",
        content: "Strategic liquidity management for sustainable growth.",
      },
      {
        id: "nft",
        title: "NFT Ecosystem",
        icon: "image",
        content: "Exclusive NFT collections for $NANA holders.",
      },
      {
        id: "community",
        title: "Community Driven",
        icon: "users",
        content: "Powered by our passionate community of banana enthusiasts.",
      },
      {
        id: "security",
        title: "Security & Transparency",
        icon: "shield",
        content: "Committed to transparent operations and security best practices.",
      },
    ],
    tokenUtility: [
      "Trading",
      "NFT-related participation",
      "Exclusive merchandise giveaways",
      "Community reward campaigns",
    ],
    development: [
      "Liquidity expansion",
      "NFT utility allocation",
      "Exclusive merchandise drops",
      "Major community raffles",
      "Third-party market listings",
    ],
    marketing: [
      {
        title: "X / Twitter Campaigns",
        description: "Engaging social media presence and viral content.",
      },
      {
        title: "Telegram Community",
        description: "Active community discussions and updates.",
      },
      {
        title: "Viral Promotions",
        description: "Creative marketing and partnerships.",
      },
      {
        title: "NFT Incentives",
        description: "Exclusive rewards for early supporters.",
      },
    ],
  },

  // Images
  images: {
    heroMascot: "https://static.prod-images.emergentagent.com/jobs/bd24f06d-c257-44d3-b821-05bccf021a15/images/5569e249a26544f1af0ec0ce3ff244f52dd4cd9787ceb8d723bae0861cbfac3b.jpeg",
    floatingBanana: "https://customer-assets-4nw71qhi.emergentagent.net/job_bd24f06d-c257-44d3-b821-05bccf021a15/artifacts/3ep04i7v_bfe2c699-b2d0-49f7-9dbf-b658ee35edec.png",
    logoIcon: "https://customer-assets-4nw71qhi.emergentagent.net/job_bd24f06d-c257-44d3-b821-05bccf021a15/artifacts/3ep04i7v_bfe2c699-b2d0-49f7-9dbf-b658ee35edec.png",
  },
};

export default siteConfig;
